import React, { useEffect, useState } from 'react';

import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { useLocation } from 'react-router-dom';

import Section from '../Section';
import { fetchTabaYahasTohnitData } from '../../server/ServerFunc';
import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';

const YahasTohnitInfo = ({ isSeparate }) => {
  const [yahasTohnitList, setYahasTohnitList] = useState([]);
  const titles = {
		"tohnit": "תוכנית",
		"sugYahasText": "סוג היחס",
		"statusText": "סטטוס התוכנית",
		"taarihStatus": "תאריך קבלה"
	}

	const search = useLocation().search;

	useEffect(() => {
		const tikNumURL = new URLSearchParams(search).get("TikNum");
		getYahasTohnitContent(tikNumURL);	
	}, []);

	const getYahasTohnitContent = async (tikNum) => { 
		const yahasTohnitData = await fetchTabaYahasTohnitData(tikNum);
		if(yahasTohnitData.length > 0) {
			setYahasTohnitList(yahasTohnitData);
		} else {
			setYahasTohnitList([]);
		}
	}

  const LabeledDataItem = (label, value) => {
		return <div className="labeled-grid-cell">
			<div className="label">{label}</div>
			<div className="value">{value}</div>
		</div>
	}

  const LabeledCell = (props) => {
		return <td {...props.tdProps}>
			{LabeledDataItem(titles[props.field], props.dataItem[props.field])}
		</td>
	}

  const YahasTohnitTable = () => {
    return (
      yahasTohnitList.length > 0 ?
        <Grid data={yahasTohnitList} >
          <GridColumn field="tohnit" title={titles.tohnit} cell={LabeledCell} />
          <GridColumn field="sugYahasText" title={titles.sugYahasText} cell={LabeledCell} />
          <GridColumn field="statusText" title={titles.statusText} cell={LabeledCell} />
          <GridColumn field="taarihStatus" title={titles.taarihStatus} cell={LabeledCell} />
        </Grid>
        :
        <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
		)
  }

  return (
	  <>
		  { isSeparate && <AppHeaderGlobal /> }
		  {
			  <div className="container my-3 my-lg-5">
				  <Section icon={'eye'} title={'יחס לתכניות אחרות'} className="mt-3">
					  <YahasTohnitTable />
				  </Section>
			  </div>
		  }
		  { isSeparate && <AppFooter /> }
	  </>
  )
}

export default YahasTohnitInfo